class YoutubeEmbed {
  constructor() {
    this.init();
  }

  init() {
    // https://developers.google.com/youtube/iframe_api_reference
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    const videos = document.querySelectorAll('.media__video');

    if (videos.length > 0) {
      videos.forEach(item => {
        item.addEventListener('click', () => {
          const img = item.querySelector('img');
          const playerId = 'media__player-' + item.getAttribute('block-id');

          item.classList.add('playing');

          new window.YT.Player(playerId, {
            width: '994',
            height: '559',
            videoId: item.getAttribute('video-id'),
            playerVars: {
              'playsinline': 1,
            },
            events: {
              onReady: onPlayerReady,
              onStateChange: onPlayerStateChange,
            },
          });

          function onPlayerReady(event) {
            event.target.playVideo();
            img.style.display = 'none';
          }

          function onPlayerStateChange(event) {
            if (event.data === 0) {
              img.style.display = 'block';
              item.classList.remove('playing');
              event.target.destroy();
            }
          }
        })
      });
    }
  }
}

export default YoutubeEmbed;



// WEBPACK FOOTER //
// ./scripts/util/youtubeEmbed.js